import type { RenderElementProps } from 'slate-react';

import { LINK, PARAGRAPH } from './constants';
import { getHref, getStyle, getTarget } from './utils';
import style from './element.module.scss';

export const ELEMENT_MAPPERS = {
  [PARAGRAPH]: ({ attributes, children, element }: RenderElementProps) => (
    <p
      {...attributes}
      style={getStyle(element)}
    >
      {children}
    </p>
  ),
  [LINK]: ({ attributes, children, element }: RenderElementProps) => (
    <a
      {...attributes}
      className={style.Link}
      href={getHref(element)}
      rel="nofollow noreferrer"
      style={getStyle(element)}
      target={getTarget(element)}
    >
      {children}
    </a>
  ),
};

type ElementTypes = 'paragraph' | 'link';

export const Element = (props: RenderElementProps) => {
  const { element } = props;
  const type = element.type as ElementTypes;
  const elementMapper = ELEMENT_MAPPERS[type] || ELEMENT_MAPPERS[PARAGRAPH];

  return elementMapper(props);
};
